(function () {
  const bar = document.getElementById('StickyAddToCart');
  if (!bar) return;

  const stickyButton = document.getElementById('StickyAddToCartButton');
  const stickyButtonText = document.getElementById('StickyAddToCartButtonText');
  const stickyPrice = document.getElementById('StickyAddToCartPrice');

  function getRealForm() {
    return document.querySelector('main#MainContent product-form .product-form__submit');
  }

  function getRealPrice() {
    return document.querySelector(
      'main#MainContent .product .price__container, main#MainContent .product .price'
    );
  }

  function syncButtonState() {
    const realButton = getRealForm();
    if (!realButton) return;
    stickyButton.disabled = realButton.disabled;
    const label = realButton.querySelector('span')?.textContent.trim();
    if (label) stickyButtonText.textContent = label;
  }

  function syncPrice() {
    const realPrice = getRealPrice();
    if (!realPrice || !stickyPrice) return;
    const saleItem = realPrice.querySelector('.price-item--sale, .price-item--regular:not(s)');
    const text = (saleItem || realPrice).textContent.trim().replace(/\s+/g, ' ');
    if (text) stickyPrice.textContent = text;
  }

  stickyButton.addEventListener('click', function () {
    const realButton = getRealForm();
    if (realButton && !realButton.disabled) realButton.click();
  });

  const realButtonInitial = getRealForm();
  if (realButtonInitial) {
    const observer = new MutationObserver(function () {
      syncButtonState();
      syncPrice();
    });
    observer.observe(realButtonInitial, { attributes: true, childList: true, subtree: true });

    const realPriceInitial = getRealPrice();
    if (realPriceInitial) {
      const priceObserver = new MutationObserver(syncPrice);
      priceObserver.observe(realPriceInitial, { childList: true, subtree: true, characterData: true });
    }
  }

  const buyButtonsBlock = document.querySelector('main#MainContent .product-form__buttons');
  if (buyButtonsBlock && 'IntersectionObserver' in window) {
    const visibilityObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          bar.classList.toggle('sticky-atc--visible', !entry.isIntersecting);
        });
      },
      { threshold: 0 }
    );
    visibilityObserver.observe(buyButtonsBlock);
  }
})();
